/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/sun'
export default icon
